<template>
  <div class="body">
    <div class="scroll-container">
      <div
        class="scroll-content"
        ref="scrollContent"
      >
        <div
          v-for="(ticket, index) in tickets"
          :key="index"
          class="ticket"
          :class="{ 'selected': ticket.selected }"
          @click="handleClick(ticket)">
          <div class="checkbox">
            <i
              v-if="ticket.selected"
              class="n-i n-i-check-a"
            />
            <i
              v-else
              class="n-i n-i-circle"
            />
          </div>
          <div class="ticket-id">
            <div class="name">ticket id</div>
            <div class="value">{{ ticket.id }}</div>
          </div>
          <div class="date">
            <div class="name">date and time</div>
            <div class="value">{{ ticket.createdAt }}</div>
          </div>
          <div class="payin">
            <div class="name">payin</div>
            <div class="value">{{ ticket.payin }}</div>
          </div>
          <div class="status">
            <div class="name">status</div>
            <div class="value">{{ ticket.status.name }}</div>
          </div>
        </div>
      </div>
      <div
        class="controls"
        :class="{ 'active': controlsActive }"
      >
        <div
          class="down"
          @click="handleScroll({ type: 'down' })"
        >
          <i class="n-i n-i-arrow-down-a" />
        </div>
        <div
          class="to-top"
          @click="handleScroll({ type: 'top' })"
        >
          <i class="n-i n-i-arrow-up-a" /> <i class="n-i n-i-arrow-up-a" /> <span>to top</span>
        </div>
        <div
          class="up"
          @click="handleScroll({ type: 'up' })"
        >
          <i class="n-i n-i-arrow-up-a" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div
        class="print-copy"
        @click="print()">
        <span>Print Copy</span>
      </div>
    </div>
    <div
      class="overlay"
      :class="{ 'active': !loaded }"
    >
      <div class="loader" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import routes from '../data/endpoints'
import { GatewaySvc } from '../services/gateway.service';
import { EventBus } from "../utilities/event.bus";
import { printFormatter }  from '../utilities/printFormatter';

export default {
  data() {
    return {
      loaded: false,
      controlsActive: false,
      ticketsList: [],
      selectedTicket: null,
    };
  },

  beforeCreate() {
    EventBus.$on('Tickets.FetchHistory', message => {
      this.fetchHistory(message);
    });
  },

  computed: {
    tickets() {
      return this.ticketsList
    }
  },

  methods: {
    handleClick(ticket) {
      const selected = ticket.selected;
      this.unselectTickets();
      ticket.selected = !selected;
      this.selectedTicket = ticket.selected ? ticket : null;
    },

    handleScroll(data) {
      const scrollTop = this.$refs.scrollContent.scrollTop;
      const scrollStep = 200;

      switch (data.type) {
        case 'up':
          this.$refs.scrollContent.scrollTop = scrollTop - scrollStep;
          break;
        case 'down':
          this.$refs.scrollContent.scrollTop = scrollTop + scrollStep;
          break;
        case 'top':
          this.$refs.scrollContent.scrollTop = 0;
          break;
        default:
          console.log(`Scroll type: ${data.type} not supported.`)
      }
    },

    fetchHistory(message) {
      const url = this.getUrl()
      message.data.deviceUuid = sevenConfig.data.device.uuid;
      this.loaded = false;

      if (url) {
        axios.get(url, {
          params: message.data,
          headers: this.getHeaders()
        })
        .then((response) => {
          this.ticketsList = response.data.message;
          this.modifyTicketList();
          this.unselectTickets();
          GatewaySvc.getGatewaySvc().sendMessage('Tickets.HistoryFetched', {
            params: {
              totalCount: this.ticketsList.length || 0
            }
          });

          this.loaded = true;
          this.toggleControls();
        })
        .catch((error) => {
          console.error(error);
        });
      }
    },

    getUrl() {
      let url = ''
      const environment = routes.ticketHistory.terminal[sevenConfig.data.ENV];
      const datacenter = sevenConfig.data.company.datacenter.split('_')[1];
      if (environment && environment[datacenter]) {
        url = `${environment[datacenter]}/${sevenConfig.data.product.cpvUuid}.json`;
      }

      return url;
    },

    getHeaders() {
      const { data } = sevenConfig;

      return {
        'HTTP-X-NAB-COMPANY-ID': data.company.id,
        'X-NSFT-SEVEN-COMPANY-UUID': data.company.uuid,
        'HTTP-X-NAB-BETSHOP-ID': data.betshop.id,
        'HTTP-X-NAB-DEVICE-UUID': data.device.uuid,
        'HTTP-X-NAB-DP': 'AdminTerminal',
        'SEVEN-LOCALE': data.company.locale,
        'Authorization': `Bearer ${data.user.auth.token}`
      }
    },

    modifyTicketList() {
      this.ticketsList = this.ticketsList.map(x => {
        x.createdAt = x.createdAt.replaceAll('-', '.');
        x.payin = x.payin.toFixed(2);
        x.isCopy = true;

        if (x.bets && x.bets.length) {
          x.bets.map(y => {
            if (!y.system) {
              delete y.system
            }
          })
        }

        return x;
      });
    },

    unselectTickets() {
      this.ticketsList = this.ticketsList.map(x => {
        x.selected = false;

        return x;
      });
    },

    print() {
      GatewaySvc.getGatewaySvc().sendMessage('Tickets.Print', {
        action: '',
        productId: 'Keno',
        type: 'ticket',
        responseData: printFormatter(this.selectedTicket)
      });

      this.unselectTickets();
    },

    toggleControls() {
      setTimeout(() => {
        const contentHeight = this.$refs.scrollContent.offsetHeight;
        this.controlsActive = false;

        if (this.ticketsList.length) {
          const ticket = document.getElementsByClassName('ticket')[0];
          this.controlsActive = this.ticketsList.length * (ticket.offsetHeight + 10) > contentHeight;
        }
      }, 100);
    },
  },
}
</script>

<style lang="scss">
@import '../../node_modules/@nsftx/nfont/css/icons.css';

$row-height: 50px;

$bg-color: #171717;
$accent-color: #0066AE;
$text-color: #EAE9E7;

$scroll-bar-bg: transparent;
$scroll-bar-color: rgba(0, 0, 0, .35);
$scroll-bar-width: 7px;
$scroll-bar-radius: 10px;

$font-primary: 'Roboto', sans-serif;

.body {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background: $bg-color;
  color: $text-color;
  font-family: $font-primary;
  overflow: hidden;
  text-transform: uppercase;

  z-index: 2;
}

.scroll-container {
  display: flex;
  flex: 1;
  position: relative;
  height: calc(100% - #{$row-height * 2} - 20px);
  padding-bottom: $row-height;
}

.scroll-content {
  flex: 1;
  overflow: hidden;
  overflow-y: overlay;

  .ticket {
    display: flex;
    height: $row-height;
    margin: 10px 0;
    cursor: pointer;
    background: #242424;
    font-size: 14px;

    &.selected {
      background: $accent-color;
    }

    > div {
      display: flex;
      flex: 1;
      justify-content: space-around;
      flex-direction: column;
      height: 100%;

      padding: 0 10px;
      text-transform: uppercase;
      border-right: 1px solid $bg-color;
    }

    .checkbox {
      flex: 0 0 50px;
      align-items: center;
      font-size: 22px;
    }
  }
}

.controls {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: $row-height;
  opacity: 0;
  transition: opacity .3s;

  &.active {
    opacity: 1;
  }

  display: flex;
  flex-direction: row;
  align-items: stretch;

  cursor: pointer;
  background: #213143;
  color: #e6e6e6;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 5px;
  }

  .up {
    background: #203142;
  }

  .to-top {
    flex-direction: column;
    justify-content: space-around;
    background: $accent-color;

    i {
      &:not(:first-child) {
        margin-top: -7px;
      }
    }

    span {
      flex-grow: 2;
    }
  }

  .down {
    background: #203142;
  }
}

.footer {
  position: relative;
  padding: 5px 0;

  .print-copy {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: $row-height;
    background: $accent-color;
    cursor: pointer;
  }
}

::-webkit-scrollbar {
  background: $scroll-bar-bg;
  width: $scroll-bar-width;
}

::-webkit-scrollbar-thumb {
  border-radius: $scroll-bar-radius;
  -webkit-box-shadow: inset 0 0 100px $scroll-bar-color;
}

::-webkit-scrollbar-track {
  border-radius: $scroll-bar-radius;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: rgba(0, 0, 0, .3);
  opacity: 0;
  transition: opacity .3s;
  z-index: -1;

  .loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 50px;
    height: 50px;
    border: 5px solid transparent;
    border-radius: 50%;
    border-left-color: $accent-color;
  }

  &.active {
    z-index: 2;
    opacity: 1;

    .loader {
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}

</style>



// WEBPACK FOOTER //
// TicketHistory.vue?50658544